import React, { Suspense, lazy } from 'react';
import { TopBar } from './components/TopBar';
import { CountdownBar } from './components/CountdownBar';
import { HeroSection } from './components/HeroSection';
const VideoProofSection = lazy(() => import('./components/VideoProofSection').then(module => ({
  default: module.VideoProofSection
})));
const BenefitsSection = lazy(() => import('./components/BenefitsSection').then(module => ({
  default: module.BenefitsSection
})));
const QualityVideoSection = lazy(() => import('./components/QualityVideoSection').then(module => ({
  default: module.QualityVideoSection
})));
const PricingSection = lazy(() => import('./components/PricingSection').then(module => ({
  default: module.PricingSection
})));
const TestimonialsSection = lazy(() => import('./components/TestimonialsSection').then(module => ({
  default: module.TestimonialsSection
})));
const FAQSection = lazy(() => import('./components/FAQSection').then(module => ({
  default: module.FAQSection
})));
export function App() {
  return <div className="min-h-screen bg-[#FFFAF7] font-sans" data-id="element-0">
      <TopBar data-id="element-1" />
      <CountdownBar data-id="element-2" />
      <main data-id="element-3">
        <HeroSection data-id="element-4" />
        <Suspense fallback={<div className="h-32" data-id="element-6" />} data-id="element-5">
          <VideoProofSection data-id="element-7" />
          <BenefitsSection data-id="element-8" />
          <QualityVideoSection data-id="element-9" />
          <PricingSection data-id="element-10" />
          <TestimonialsSection data-id="element-11" />
          <FAQSection data-id="element-12" />
        </Suspense>
      </main>
      <footer className="bg-[#2D2D3F] text-white py-6 text-center text-sm opacity-90" data-id="element-13">
        <p data-id="element-14">
          © {new Date().getFullYear()} Mega Pack Disney. Todos los derechos
          reservados.
        </p>
      </footer>
    </div>;
}